import React, { useState, useEffect } from "react";
import styled, { css } from "styled-components";
import GameOverLayer from "../../ui/GameOverLayer";
import Timer from "../../ui/Timer";

const PossibleAnswerSymbol = styled.img`
  height: 75px;
  width: 75px;
  cursor: pointer;
`;

const AnswerRow = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
`;

const AnswerField = styled.div<{
  answered: boolean;
  url: string;
  correct: boolean;
}>`
  height: 60px;
  width: 60px;
  border-radius: 35px;
  margin: 5px;
  background-color: #eee;
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  font-size: 32px;
  font-weight: bolder;
  text-align: center;
  background-size: 110%;
  background-repeat: no-repeat;
  background-position: center;
  ${(p: any) =>
    p.answered &&
    css`
      background-image: url(${p.url});
      ${!p.correct && `opacity: 0.7;`}
    `}
`;

const PossibleAnswerTable = styled.table`
  margin-top: 10px;
  margin-bottom: 30px;
  margin-left: auto;
  margin-right: auto;
`;

const CorrectText = styled.strong`
  color: #0e0;
`;

const WrongText = styled.strong`
  color: #e00;
`;

const Strong = styled.strong`
  font-size: 30px;
`;

const AnswerGrid = ({ answerSymbols, onPossibleAnswerClick }: any) => {
  let rows: any = [];
  let columns: any = [];
  const numberOfCols = answerSymbols.length / 3;
  answerSymbols.forEach((symbol: any, index: number) => {
    if (index % numberOfCols === 0) {
      rows.push(<tr key={index}>{columns}</tr>);
      columns = [];
    }
    columns.push(
      <td key={index}>
        <PossibleAnswerSymbol
          onClick={() => onPossibleAnswerClick(symbol, index)}
          src={symbol}
        />
      </td>
    );
  });
  rows.push(<tr>{columns}</tr>);
  return <PossibleAnswerTable>{rows}</PossibleAnswerTable>;
};

const AnswerScreen = ({
  level,
  symbols,
  memorizeSymbols,
  setGameOver,
  gameOver,
}: any) => {
  const numberOfPossibleAnswers = level === 1 ? 12 : level === 2 ? 15 : 18;
  const sekunden = level === 1 ? 10 : level === 2 ? 15 : 18;
  const [currentAnswerNumber, setCurrentAnswerNumber] = useState(0);
  const [correctAnswers, setCorrectAnswers]: any = useState([]);
  const [wrongAnswers, setWrongAnswers]: any = useState([]);
  const [timer, setTimer] = useState(sekunden * 1000);
  const [opacity,setOpacity] = useState(0);

  const onPossibleAnswerClick = (symbol: string, index: number) => {
    symbol === memorizeSymbols[currentAnswerNumber]
    ? setCorrectAnswers([...correctAnswers, currentAnswerNumber])
    : setWrongAnswers([...wrongAnswers, currentAnswerNumber]);
    setCurrentAnswerNumber(currentAnswerNumber + 1);
  };

  useEffect(() => {
    setTimeout(() => setOpacity(1),100);
  }, []);

  useEffect(() => {
    if (timer > 0 && currentAnswerNumber < memorizeSymbols.length)
      setTimeout(() => setTimer(timer - 100), 100);
    else setGameOver(true);
  }, [timer]);

  return (
    <div
      style={{
        transition: "opacity 1s",
        opacity,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {gameOver && (
        <GameOverLayer>
          Sie haben <Strong>{Math.floor((sekunden - (timer/1000) ) * 10) / 10}</Strong> Sekunden gebraucht, um{" "}
          <Strong>{correctAnswers.length}</Strong> richtige Antworten zu geben.
        </GameOverLayer>
      )}
      <AnswerGrid
        answerSymbols={symbols}
        onPossibleAnswerClick={onPossibleAnswerClick}
      />
      <AnswerRow>
        {memorizeSymbols.map((symbol: any, index: number) => {
          return (
            <AnswerField
              url={symbol}
              answered={currentAnswerNumber > index}
              correct={correctAnswers.includes(index)}
            >
              {currentAnswerNumber > index ? (
                correctAnswers.includes(index) ? (
                  <CorrectText>✓</CorrectText>
                ) : (
                  <WrongText>X</WrongText>
                )
              ) : (
                ""
              )}
            </AnswerField>
          );
        })}
      </AnswerRow>
      <Timer time={timer} />
    </div>
  );
};

export default AnswerScreen;
